"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringToHTML = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const StringToHTML = (htmlString, ref = null, className = '') => ((0, jsx_runtime_1.jsx)("span", { className: className, ref: ref, dangerouslySetInnerHTML: { __html: htmlString } }));
exports.StringToHTML = StringToHTML;
